import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { postPreferredName } from '../../apis/settings.api';
import { getMerchantInfo } from '../../apis/user.api';
import { routes } from '../../config/routes.config';
import { useGlobalStateContext } from '../GlobalStateContext/GlobalStateContext';
//Defining initial state
export const initialState = {
    apiReply: {
        success: false,
        reason: 'null',
    },
    step: Number(localStorage.getItem('idi-onboarding-step')),
};
export const OnboardingContext = createContext(undefined);
// Creating a custom hook to access the context
export function useOnboardingContext() {
    const context = useContext(OnboardingContext);
    if (!context) {
        throw new Error('useOnboardingContext must be used within an OnboardingContextProvider');
    }
    return context;
}
// Creating a provider component
export const OnboardingContextProvider = ({ children, }) => {
    const [onboardingContextState, setOnboardingContextState] = useState(initialState);
    const { smssetup } = routes;
    const { 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    globalState: { merchant }, updateGlobalState, } = useGlobalStateContext();
    const navigate = useNavigate();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const onboardingAPIEndPoint = {
        completeOnboarding: '/user/completeOnboarding',
    };
    const updateStep = (step) => {
        setOnboardingContextState((prevState) => ({
            ...prevState,
            step,
        }));
        localStorage.setItem('idi-onboarding-step', step.toString());
    };
    const processOnboarding = async (payload, step) => {
        if (!merchant || !merchant.number || merchant.number === 0 || merchant.number === null) {
            return;
        }
        try {
            const res = await postPreferredName({
                merchantNumber: merchant?.number,
                ...payload,
            }, onboardingAPIEndPoint.completeOnboarding);
            const response = res;
            const { success, reason, failureCode } = response || {};
            setOnboardingContextState((prevState) => ({
                ...prevState,
                apiReply: {
                    success,
                    reason,
                    failureCode,
                },
            }));
            if (success && step === 6) {
                //we are on mobile and we need to navigate to sms setup
                navigate(smssetup);
            }
            // When user sets/skip preferred name. They just onboarded the merchant and confirmed TOU + business info
            if (success && step === 2) {
                try {
                    getMerchantInfo().then((merchantList) => {
                        updateGlobalState({ merchantList });
                    });
                }
                catch (e) {
                    console.log(e);
                }
            }
            if (success) {
                updateStep(step);
            }
        }
        catch (error) {
            console.log(error);
        }
    };
    const contextValue = {
        onboardingContextState,
        setOnboardingContextState,
        processOnboarding,
        updateStep,
    };
    return _jsx(OnboardingContext.Provider, { value: contextValue, children: children });
};
